export const FORM_STATUS = {
  LOADING: "pending",
  ERROR: "error",
  SUCCESS: "success",
};

export const ROLES = {
  USER: "user",
  ADMIN: "admin",
};

export const DEFAULT_ITEMS_PER_PAGE = 10;
export const DEFAULT_ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100];

export const PLATFORMS = {
  AMAZON: "amazon",
  APPLE_APPSTORE: "appleappstore",
  APPLE_PODCASTS: "applepodcasts",
  FACEBOOK: "facebook",
  G2: "g2",
  GARTNER: "gartner",
  GLASSDOOR: "glassdoor",
  GOOGLE: "google",
  GOOGLE_PLAYSTORE: "googleplaystore",
  KUNUNU: "kununu",
  PROVEN_EXPERT: "provenexpert",
  REVIEWFOREST: "reviewforest",
  TRUSTEDSHOPS: "trustedshops",
  TRUSTPILOT: "trustpilot",
};

export const PLATFORM_TYPES = [
  {
    id: PLATFORMS.AMAZON,
    name: "Amazon",
    color: "#FF9900",
  },
  {
    id: PLATFORMS.APPLE_APPSTORE,
    name: "Apple App Store",
    color: "#FF3B30",
  },
  {
    id: PLATFORMS.APPLE_PODCASTS,
    name: "Apple Podcasts",
    color: "#FF3B30",
  },
  {
    id: PLATFORMS.FACEBOOK,
    name: "Facebook",
    color: "#1877F2",
  },
  {
    id: PLATFORMS.G2,
    name: "G2",
    color: "#FE492C",
  },
  {
    id: PLATFORMS.GARTNER,
    name: "Gartner",
    color: "#3FB3E0",
  },
  {
    id: PLATFORMS.GLASSDOOR,
    name: "Glassdoor",
    color: "#0CAA41",
  },
  {
    id: PLATFORMS.GOOGLE,
    name: "Google",
    color: "#4285F4",
  },
  {
    id: PLATFORMS.GOOGLE_PLAYSTORE,
    name: "Google Play Store",
    color: "#4285F4",
  },
  {
    id: PLATFORMS.KUNUNU,
    name: "Kununu",
    color: "#FF6600",
  },
  {
    id: PLATFORMS.PROVEN_EXPERT,
    name: "ProvenExpert",
    color: "#009688",
  },
  {
    id: PLATFORMS.REVIEWFOREST,
    name: "RF Direct",
    color: "#97C940",
  },
  {
    id: PLATFORMS.TRUSTEDSHOPS,
    name: "Trusted Shops",
    color: "#FFDC0C",
  },
  {
    id: PLATFORMS.TRUSTPILOT,
    name: "Trustpilot",
    color: "#00B67A",
  },
];

export const PROJECT_TYPES = [
  {
    id: 1,
    name: "P2P",
    location: "Mexico",
    color: "#4285F4",
  },
  {
    id: 2,
    name: "Eden",
    location: "Madagascar",
    color: "#FF9900",
  },
  {
    id: 3,
    name: "ReForest",
    location: "Australia",
    color: "#00A651",
  },
  {
    id: 4,
    name: "NSLF",
    location: "Germany",
    color: "#FF3B30",
  },
  {
    id: 5,
    name: "Eden",
    location: "Kenya",
    color: "#CF29DF",
  },
  {
    id: 6,
    name: "Future",
    location: "Senegal",
    color: "#3FB3E0",
  },
];

export const TREE_TYPES = [
  {
    id: "review",
    name: "Review",
  },
  {
    id: "additionalTree",
    name: "Additional Tree",
  },
];

export const LANGUAGES = [
  {
    id: "de",
    name: "German",
    color: "#4285F4",
  },
  {
    id: "en",
    name: "English",
    color: "#FF9900",
  },
  {
    id: "fr",
    name: "French",
    color: "#00A651",
  },
];

export const ORDER_COLORS = {
  printTemplate: "#4285F4",
  additionalTree: "#FF9900",
};

export const FOREST_TYPES = {
  BRAND: "brand",
  SINGLE: "single",
};

export const TREE_PLANTING_OPTION = {
  ONLY_NEW_REVIEWS: 1,
  ALL_REVIEWS: 0,
};

export const INVOICE_STATUS = {
  DRAFT: "draft",
  PARTIAL_REFUND: "pratial_refund",
  FULL_REFUND: "full_refund",
  PAID: "paid",
};

export const INVOICE_TYPES = {
  MESSAGE: "message",
  PLAN: "plan",
  PRINT: "print",
  TREES: "planting-project",
};

export const EMAIL_TYPES = [
  {
    id: "invitation",
    name: "Invitation",
    color: "#1E90FF", // Dodger Blue
  },
  {
    id: "managerConfirmation",
    name: "Manager Confirmation",
    color: "#32CD32", // Lime Green
  },
  {
    id: "orderPrintMaterial",
    name: "Order Print Material",
    color: "#FF8C00", // Dark Orange
  },
  {
    id: "passwordReset",
    name: "Password Reset",
    color: "#FF1493", // Deep Pink
  },
  {
    id: "removeTeamMember",
    name: "Remove Team Member",
    color: "#8B0000", // Dark Red
  },
  {
    id: "reviewDirectTreeCertificate",
    name: "Review Direct Tree Certificate",
    color: "#20B2AA", // Light Sea Green
  },
  {
    id: "reviewDirectVerification",
    name: "Review Direct Verification",
    color: "#6A5ACD", // Slate Blue
  },
  {
    id: "reviewNotifications",
    name: "Review Notifications",
    color: "#FFD700", // Gold
  },
  {
    id: "subscriptionPlanRenewal",
    name: "Subscription Plan Renewal",
    color: "#FF4500", // Orange Red
  },
  {
    id: "teamMemberConfirmation",
    name: "Team Member Confirmation",
    color: "#2E8B57", // Sea Green
  },
  {
    id: "teamMemberInvitation",
    name: "Team Member Invitation",
    color: "#9370DB", // Medium Purple
  },
  {
    id: "userVerification",
    name: "User Verification",
    color: "#00CED1", // Dark Turquoise
  },
];

export const EMAIL_SENDING_TYPES = {
  PROCESSED: "processed",
  DROPPED: "dropped",
  DEFERRED: "deferred",
  BOUNCE: "bounce",
  DELIVERED: "delivered",
  SENDING: "sending",
  OPEN: "open",
  CLICK: "click",
  SPAM_REPORT: "spam_report",
  SPAMREPORT: "spamreport",
  UNSUBSCRIBE: "unsubscribe",
  GROUP_UNSUBSCRIBE: "group_unsubscribe",
};

export const SENDGRID_EMAIL_STATUS = [
  {
    id: EMAIL_SENDING_TYPES.BOUNCE,
    name: "Bounce",
    color: "#FF9900",
  },
  {
    id: EMAIL_SENDING_TYPES.CLICK,
    name: "Click",
    color: "#97C940",
  },
  {
    id: EMAIL_SENDING_TYPES.DEFERRED,
    name: "Deferred",
    color: "#97C940",
  },
  {
    id: EMAIL_SENDING_TYPES.DELIVERED,
    name: "Delivered",
    color: "#4285F4",
  },
  {
    id: EMAIL_SENDING_TYPES.DROPPED,
    name: "Dropped",
    color: "#FF3B30",
  },
  {
    id: EMAIL_SENDING_TYPES.GROUP_UNSUBSCRIBE,
    name: "Group Unsubscribe",
    color: "#FFDC0C",
  },
  {
    id: EMAIL_SENDING_TYPES.OPEN,
    name: "Open",
    color: "#3FB3E0",
  },
  {
    id: EMAIL_SENDING_TYPES.PROCESSED,
    name: "Processed",
    color: "#FF6600",
  },
  {
    id: EMAIL_SENDING_TYPES.SENDING,
    name: "Sending",
    color: "#FE492C",
  },
  {
    id: EMAIL_SENDING_TYPES.SPAM_REPORT,
    name: "Spam Report",
    color: "#009688",
  },
  {
    id: EMAIL_SENDING_TYPES.SPAMREPORT,
    name: "Spam Report",
    color: "#009688",
  },
  {
    id: EMAIL_SENDING_TYPES.UNSUBSCRIBE,
    name: "Unsubscribe",
    color: "#0CAA41",
  },
  {
    id: EMAIL_SENDING_TYPES.GROUP_UNSUBSCRIBE,
    name: "Group Resubscribe",
    color: "#0CAA41",
  },
];
